import svg4everybody from 'svg4everybody';
import $ from 'jquery';
import {slider}from './slider';
import {autosize}from './autosize';

$(() => {
	svg4everybody();
	const jsSlider = slider();
	jsSlider.init({
		track: '#slider-track',
		thump: '#slider-thumb',
		result: '#js-master-level'
	});
	const textarea = autosize();
	textarea.init('.about__story-place');
});



// WEBPACK FOOTER //
// ./app/scripts/app.js